import Axios from 'axios';
import { IS_PRODUCTION } from 'constants/Environment';
import { getLang } from 'utils/literals';

const axios = Axios.create({
    timeout: 45000, // same as backend4
    withCredentials: false,
    maxContentLength: 128 * 1024 * 1024,
    baseURL: IS_PRODUCTION
        ? 'https://external.forcemanager.net/api'
        : 'https://externalpre.forcemanager.net/api',
});

export const createImplementation = (token, data) =>
    axios.post('/v1/implementation?deviceType=101&clientVersion=1', data, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

export const checkImplementation = (token, tag) =>
    axios.get(`/v1/implementation/${tag}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });

export const sendVerifyCode = (email) =>
    axios.post('/v1/implementation/process/email/send', {
        email,
        language: getLang(),
    });

export const verifyCode = ({ email, code }) =>
    axios.post('/v1/implementation/process/email/verificate', { email, code });
